import React from "react";
import { Users, Target } from "lucide-react";
import { Section, Reveal } from "./shared";

export default function Comparison() {
  return (
    <Section id="comparison" bg="bg-brand-cream">
      <Reveal className="max-w-3xl mx-auto text-center">
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98]">
          Stop Chasing Subscribers.<br />
          <span className="text-brand-green">Start Attracting Potential Customers.</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 mt-12 items-stretch">
        {/* Left — random subscribers */}
        <Reveal>
          <div className="h-full rounded-[30px] border-2 border-brand-black bg-brand-grey p-8 sm:p-10">
            <span className="h-12 w-12 rounded-2xl bg-brand-black flex items-center justify-center border-2 border-brand-black">
              <Users size={22} className="text-brand-grey" />
            </span>
            <p className="font-display text-6xl sm:text-7xl mt-6 text-brand-ink/40">100K</p>
            <p className="font-bold text-xl mt-1 text-brand-ink/60">Random Subscribers</p>
            <p className="text-sm sm:text-base text-brand-ink/60 mt-4 leading-relaxed">
              A large number may look impressive, but it does not automatically create trust, customers, or revenue.
            </p>
          </div>
        </Reveal>

        {/* Right — relevant customers */}
        <Reveal delay={0.1}>
          <div className="h-full rounded-[30px] border-2 border-brand-black bg-brand-yellow p-8 sm:p-10 relative overflow-hidden"
            style={{ boxShadow: "10px 12px 0 #0B31EB" }}>
            <span className="absolute top-5 right-5 rounded-full bg-brand-black text-brand-yellow text-[10px] font-bold uppercase tracking-widest px-3 py-1">More Valuable</span>
            <span className="h-12 w-12 rounded-2xl bg-brand-blue flex items-center justify-center border-2 border-brand-black">
              <Target size={22} className="text-white" />
            </span>
            <p className="font-display text-6xl sm:text-7xl mt-6 text-brand-black">1K</p>
            <p className="font-bold text-xl mt-1">Relevant Potential Customers</p>
            <p className="text-sm sm:text-base text-brand-ink/80 mt-4 leading-relaxed">
              People with real questions, real problems, and real intent—who may need your expertise, service, course, or product.
            </p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
